<template>
    <el-card>
        <template #header>
            <content-header/>
        </template>
        <div v-show="infoDiv">
            <p>
                选择区域:
                <el-select
                    @change="changeSelect"
                    class="selectwidth"
                    placeholder="请选择"
                    size="small"
                    v-model="area"
                >
                    <el-option
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        v-for="item in areas"
                    />
                </el-select>
            </p>
            <el-card class="cards">
                <p>
                    共享电单车在骑行中，起步价为<span class="span-red">{{ form.starting_price_time }}</span>分钟内<span class="span-red">{{ form.starting_price }}</span>
                    元，
                    之后每 <span class="span-red">{{ form.per_minute }}</span> 分钟收取 <span class="span-red">{{ form.per_money }}</span>
                    元费用，
                </p>

                <p>
                    当用户不在指定区域还车时，
                    <span class="span-red">{{ form.min_limit_km }}</span>米内，另收 <span class="span-red">{{ form.min_dispatching_fee }}</span>
                    元调度费，<span class="span-red">{{ form.min_limit_km }}</span>米外，每增加<span class="span-red">{{ form.over_limit_per_km }}</span>千米，多收取<span
                    class="span-red">{{ form.over_limit_per_km_money }}</span>元
                </p>
                <p>
                    最高封顶 <span class="span-red">{{ form.max_dispatching_fee }}</span> 元，
                    <span class="p-green">注意：最高封顶为0元时，表示无封顶</span>
                </p>
                <p>
                    电量低于 <span class="span-red">{{ form.power_lower }}</span> %以下禁止骑行，
                </p>
            </el-card>

            <el-card class="cards">
                <p>
                    <span class="it-tital">是否开启分钟内免费骑行： </span> <span class="span-red"
                                                                      v-if="form.is_minute_free==0"> 否</span> <span
                    class="span-red" v-if="form.is_minute_free==1"> 是</span>
                    <span class="span-red" style="margin-left:15px;">{{ form.many_minute_free }}</span>分钟(包含)内免费骑行,
                    每日免费骑行次数上限<span class="span-red">{{ form.minute_free_times }}</span>(0为无上限)
                </p>
                <p><span class="it-tital">是否需要提前充值： </span> <span class="span-red"
                                                                  v-if="form.is_advance_recharge==0"> 否</span> <span
                    class="span-red" v-if="form.is_advance_recharge==1"> 是</span></p>
                <p>
                    <span class="it-tital">能否全运营区域还车： </span> <span class="span-red"
                                                                    v-if="form.is_whole_area_huanche==0"> 否</span> <span
                    class="span-red"
                    v-if="form.is_whole_area_huanche==1"
                > 是</span>
                </p>
                <p>
                    <span class="it-tital">是否启用还车点辐射范围： </span> <span class="span-red"
                                                                      v-if="form.is_parking_fushe==0"> 否</span> <span
                    class="span-red"
                    v-if="form.is_parking_fushe==1"
                > 是</span>
                </p>
                <p>
                    <span>是否只能在还车点内还车： </span> <span class="span-red" v-if="form.is_must_parking==0"> 否</span> <span
                    class="span-red" v-if="form.is_must_parking==1"> 是</span>
                </p>

                <p>
                    <span class="it-tital">是否需要实名认证： </span> <span class="span-red"
                                                                   v-if="form.is_card==0"> 否</span> <span
                    class="span-red"
                    v-if="form.is_card==1"
                > 是</span>
                </p>
                <p>
                    <span class="it-tital">是否开启学生认证免押金： </span> <span class="span-red"
                                                                      v-if="form.is_student==0"> 否</span> <span
                    class="span-red"
                    v-if="form.is_student==1"
                > 是</span>
                </p>
                <p>
                    <span class="it-tital">是否需要押金： </span> <span class="span-red" v-if="form.is_deposit==0"> 否</span>
                    <span
                        class="span-red" v-if="form.is_deposit==1"> 是</span>
                    <span style="margin-left: 15px;">押金金额：</span><span class="span-red">{{ form.deposit }}</span>
                </p>
                <!--        <p><span class="it-tital">押金金额：</span><span class="span-red">{{ form.deposit }}</span> </p>-->
                <p><span class="it-tital">是否开启退押金看广告： </span> <span class="span-red"
                                                                    v-if="form.is_return_deposit_ad_video==0"> 否</span>
                    <span
                        class="span-red" v-if="form.is_return_deposit_ad_video==1"> 是</span></p>
            </el-card>
            <!--        <el-card class="cards" style="border-top:solid 2px #ccc;padding-top:10px;">-->
            <!--            <p>-->
            <!--                <span>是否只能在还车点内还车： </span> <span class="span-red" v-if="form.is_must_parking==0"> 否</span> <span-->
            <!--                class="span-red" v-if="form.is_must_parking==1"> 是</span>-->
            <!--            </p>-->

            <!--        &lt;!&ndash; <span> <span>是否自动退还押金： </span>    <span class="span-red" v-if="form.is_auto_return_deposit==0"> 否</span> <span class="span-red" v-if="form.is_auto_return_deposit==1"> 是</span></p> &ndash;&gt;-->
            <!--        <p> <span>是否开启日租模式： </span>    <span class="span-red" v-if="form.is_open_day_rent==0"> 否</span> <span class="span-red" v-if="form.is_open_day_rent==1"> 是</span></p>-->
            <!--        <p>-->
            <!--          日租模式，全天车辆基础租金金额为 <span class="span-red">{{ form.day_rent_money }}</span>元，日租可用时长为<span class="span-red">{{ form.day_rent_hours }}</span>小时，-->
            <!--          在一天内（即24小时内）租用时长超过此时长，每一小时收取<span class="span-red">{{ form.per_hours_day_rent_timeout_money }}</span>元。<span class="span-red">{{ form.day_rent_capping_money }}</span>元封顶。-->
            <!--        </p>-->
            <!--      &lt;!&ndash;-->
            <!--      <img-->
            <!--        v-if="form.day_rent_img"-->
            <!--        :src="form.day_rent_img"-->
            <!--        class="avatara"-->
            <!--      > &ndash;&gt;-->
            <!--        </el-card>-->

            <el-button @click="changeInfo">修改</el-button>
        </div>
        <div v-show="infoForm">
            <el-form :model="form" label-width="80px" ref="form">
                <p>
                    选择区域:
                    <el-select
                        @change="changeSelect"
                        class="selectwidth"
                        placeholder="请选择"
                        size="small"
                        v-model="area"
                    >
                        <el-option
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            v-for="item in areas"
                        />
                    </el-select>
                </p>
                <el-card class="cards">
                    <p>
                        共享电单车在骑行中，起步价为
                        <el-input class="input-wid" v-model="form.starting_price_time"/>
                        分钟内
                        <el-input class="input-wid" v-model="form.starting_price"/>
                        元，
                        之后每
                        <el-input class="input-wid" v-model="form.per_minute"/>
                        分钟收取
                        <el-input class="input-wid" v-model="form.per_money"/>
                        元费用，
                    </p>

                    <p>
                        当用户不在指定区域还车时，
                        <el-input class="input-wid" v-model="form.min_limit_km"/>
                        米内,另收
                        <el-input class="input-wid" v-model="form.min_dispatching_fee"/>
                        元调度费，{{ form.min_limit_km }}米外，每增加
                        <el-input class="input-wid" v-model="form.over_limit_per_km"/>
                        米，多收取
                        <el-input class="input-wid" v-model="form.over_limit_per_km_money"/>
                        元
                    </p>
                    <p>
                        最高封顶
                        <el-input class="input-wid" v-model="form.max_dispatching_fee"/>
                        元，<span class="p-green">注意：最高封顶为0元时，表示无封顶</span>
                    </p>

                    <p>
                        电量低于
                        <el-input class="input-wid" v-model="form.power_lower"/>
                        %以下禁止骑行，
                    </p>
                </el-card>

                <el-card class="cards">

            <span class="it-tital">是否开启分钟内免费骑行：
            </span>
                    <el-radio label="1" v-model="form.is_minute_free">是</el-radio>
                    <el-radio label="0" v-model="form.is_minute_free">否</el-radio>

                    <el-input class="input-wid" style="margin-left:15px;" v-model="form.many_minute_free"/>
                    分钟(包含)内免费骑行,
                    每日免费骑行次数上限
                    <el-input class="input-wid" v-model="form.minute_free_times"/>
                    (0为无上限)
                    </p>
                    <p>
            <span class="it-tital">是否需要提前充值：
            </span>
                        <el-radio label="1" v-model="form.is_advance_recharge">是</el-radio>
                        <el-radio label="0" v-model="form.is_advance_recharge">否</el-radio>
                    </p>
                    <p>
            <span class="it-tital">能否全运营区域还车：
            </span>
                        <el-radio label="1" v-model="form.is_whole_area_huanche">是</el-radio>
                        <el-radio label="0" v-model="form.is_whole_area_huanche">否</el-radio>
                    </p>
                    <p>
            <span class="it-tital">是否启用还车点辐射范围：
            </span>

                        <el-radio label="1" v-model="form.is_parking_fushe">是</el-radio>
                        <el-radio label="0" v-model="form.is_parking_fushe">否</el-radio>
                    </p>

                    <p>
          <span>是否只能在还车点内还车：
            <el-radio label="1" v-model="form.is_must_parking">是</el-radio>
            <el-radio label="0" v-model="form.is_must_parking">否</el-radio>
          </span>
                    </p>
                    <p>

                    <p>
            <span class="it-tital">是否需要实名认证：
            </span>

                        <el-radio label="1" v-model="form.is_card">是</el-radio>
                        <el-radio label="0" v-model="form.is_card">否</el-radio>
                    </p>
                    <p>
            <span class="it-tital">是否开启学生认证免押金：
            </span>

                        <el-radio label="1" v-model="form.is_student">是</el-radio>
                        <el-radio label="0" v-model="form.is_student">否</el-radio>
                    </p>
                    <p>
            <span class="it-tital">是否需要押金：

            </span>
                        <el-radio label="1" v-model="form.is_deposit">是</el-radio>
                        <el-radio label="0" v-model="form.is_deposit">否</el-radio>
                        <span style="margin-left: 15px;">押金金额：</span>
                        <el-input class="input-wid" v-model="form.deposit"/>
                        元
                    </p>
                    <!--          <p>-->
                    <!--            <span class="it-tital">押金金额：-->
                    <!--            </span>-->

                    <!--            <el-input class="input-wid" v-model="form.deposit"/> 元-->
                    <!--          </p>-->
                    <p>
            <span class="it-tital">是否开启退押金看广告：
            </span>
                        <el-radio label="1" v-model="form.is_return_deposit_ad_video">是</el-radio>
                        <el-radio label="0" v-model="form.is_return_deposit_ad_video">否</el-radio>
                    </p>
                    <!-- <p>
                      <span>是否自动退还押金：
                        <el-radio v-model="form.is_auto_return_deposit" label="1">是</el-radio>
                        <el-radio v-model="form.is_auto_return_deposit" label="0">否</el-radio>
                      </span>
                    </p> -->
                </el-card>

                <!--        <el-card class="cards" style="border-top:solid 2px #ccc;padding-top:10px;">-->
                <!--          <p>-->
                <!--            <span>是否开启日租模式：-->
                <!--              <el-radio v-model="form.is_open_day_rent" label="1">是</el-radio>-->
                <!--              <el-radio v-model="form.is_open_day_rent" label="0">否</el-radio>-->
                <!--            </span>-->
                <!--          </p>-->
                <!--          <p>-->
                <!--            日租模式，全天车辆基础租金金额为 <el-input class="input-wid" v-model="form.day_rent_money"/> 元，日租可用时长为<el-input class="input-wid" v-model="form.day_rent_hours"/>小时，-->
                <!--            在一天内（即24小时内）租用时长超过此时长，每一小时收取 <el-input class="input-wid" v-model="form.per_hours_day_rent_timeout_money"/> 元，<el-input class="input-wid" v-model="form.day_rent_capping_money"/>元封顶。-->
                <!--          </p>-->
                <!--        </el-card>-->

                <!-- <el-upload
                  class="avatar-uploader"
                  action="/admin-api/area_setting/uploadImg"
                  name="image"
                  :headers="uploadHeaders"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <img v-if="form.day_rent_img" :src="form.day_rent_img" class="avatara">
                  <i v-else class="el-icon-plus avatar-uploader-icon"/>
                </el-upload> -->
                <el-button @click="cancleChange">取消</el-button>
                <el-button @click="submitChange">确认</el-button>
            </el-form>
        </div>
    </el-card>
</template>

<script>

    import {getAreas} from '@/api/area'
    import {getAreaSettings, updateAreaSettings} from '@/api/area-settings'
    import {getToken} from '@/libs/token'

    export default {
        name: 'Index',
        components: {},
        data() {
            return {
                areas: [],
                area_settings: [],
                page: null,
                infoDiv: true,
                infoForm: false,
                area: '',
                form: {
                    id: '',
                    per_minute: '',
                    per_money: '',
                    min_dispatching_fee: '',
                    max_dispatching_fee: '',
                    min_limit_km: 0,
                    over_limit_per_km: 0,
                    over_limit_per_km_money: 0,
                    power_lower: '',
                    is_deposit: '1',
                    is_card: '1',
                    is_student: '0',
                    deposit: '',
                    // is_auto_return_deposit: ''1,
                    is_parking: '1',
                    is_advance_recharge: '0',
                    is_whole_area_huanche: '0',
                    is_parking_fushe: '1',
                    is_open_day_rent: '1',
                    is_return_deposit_ad_video: '0',
                    day_rent_money: '',
                    day_rent_hours: '',
                    per_hours_day_rent_timeout_money: '',
                    day_rent_capping_money: '',
                    day_rent_img: '',
                    many_minute_free: 0,
                    is_minute_free: 0,
                    minute_free_times: 0,
                    starting_price_time: 10,
                    starting_price: 1,
                    is_must_parking: 0,
                },
                uploadHeaders: {
                    Authorization: '',
                },
            }
        },
        methods: {
            changeInfo() {
                this.infoDiv = false
                this.infoForm = true
            },
            cancleChange() {
                this.infoDiv = true
                this.infoForm = false
            },
            submitChange() {
                // console.log(this.form)
                updateAreaSettings(this.form.id, this.form).then(res => {
                    res.then(data => {
                        if (data) {
                            this.$message({
                                type: 'success',
                                message: '修改成功!',
                            })
                        }
                        this.infoDiv = true
                        this.infoForm = false
                    })
                })
            },
            changeSelect() {
                this.area_settings.forEach(item => {
                    if (item.area_id == this.area) {
                        this.fillForm(item)
                    }
                })
            },
            fillForm(data) {
                this.form.id = data.id
                this.form.per_minute = data.per_minute
                this.form.per_money = data.per_money
                this.form.min_dispatching_fee = data.min_dispatching_fee
                this.form.max_dispatching_fee = data.max_dispatching_fee
                this.form.power_lower = data.power_lower
                this.form.is_parking = data.is_parking.toString()
                this.form.is_advance_recharge = data.is_advance_recharge.toString()
                this.form.is_whole_area_huanche = data.is_whole_area_huanche.toString()
                this.form.is_parking_fushe = data.is_parking_fushe.toString()
                this.form.is_deposit = data.is_deposit.toString()
                this.form.is_card = data.is_card.toString()
                this.form.deposit = data.deposit
                this.form.is_auto_return_deposit = data.is_auto_return_deposit.toString()
                this.form.is_open_day_rent = data.is_open_day_rent.toString()
                this.form.is_return_deposit_ad_video = data.is_return_deposit_ad_video.toString()
                this.form.day_rent_money = data.day_rent_money
                this.form.day_rent_hours = data.day_rent_hours
                this.form.per_hours_day_rent_timeout_money = data.per_hours_day_rent_timeout_money
                this.form.day_rent_capping_money = data.day_rent_capping_money
                this.form.day_rent_img = data.day_rent_img
                this.form.over_limit_per_km = data.over_limit_per_km
                this.form.min_limit_km = data.min_limit_km
                this.form.over_limit_per_km_money = data.over_limit_per_km_money
                this.form.many_minute_free = data.many_minute_free
                this.form.minute_free_times = data.minute_free_times
                this.form.is_minute_free = data.is_minute_free.toString()
                this.form.starting_price_time = data.starting_price_time
                this.form.starting_price = data.starting_price
                this.form.is_must_parking = data.is_must_parking.toString()
            },
            handleAvatarSuccess(res, file) {
                this.form.day_rent_img = res.path
                // console.log(res)
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg'
                const isPNG = file.type === 'image/png'
                const isLt2M = file.size / 1024 / 1024 < 2

                if (!isJPG && !isPNG) {
                    this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!')
                }
                return (isJPG || isPNG) && isLt2M
            },
        },
        async created() {
            this.uploadHeaders.Authorization = getToken()
            // eslint-disable-next-line camelcase
            const [{data: areas}, {data: area_settings}] = await Promise.all([
                getAreas({all: 1}), getAreaSettings({all: 1}),
            ])

            this.areas = areas
            // eslint-disable-next-line camelcase
            this.area_settings = area_settings
            this.area = this.area_settings[0].area_id
            this.fillForm(this.area_settings[0])
        },
    }
</script>
<style lang="scss" scoped>
    .input-wid {
        width: 80px;
    }

    .p-green {
        color: #3e9;
    }

    .span-red {
        color: red;
        padding-left: 3px;
        padding-right: 3px;
    }

    .selectwidth {
        width: 150px;
    }

    .avatar-uploader .el-upload {
        border: 1px solid #ccc;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        border: 1px solid #ccc;
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatara {
        /* width: 178px; */
        width: 300px;
        height: 1000px;
        display: block;
    }

    .cards {
        margin-bottom: 20px;

        .it-tital {
            width: 210px;
            // float:right;
            display: inline-block;
            text-align: right;
        }
    }
</style>
